<div class="sso-container">
  <img class="logo" [src]="themeService.dashboardHeaderLogoUrl" />
  <i>verify token ...</i>
</div>
